// extracted by css-extract-rspack-plugin
export default {"planeImage":"ThanksForYourInterestPage_planeImage__XNsHg"};